module.exports = "//static.hsappstatic.net/pricing-pages-ui/static-1.26936/js/img/valuePropsSection/freeOnlineTraining.png"